<div class="row mb-4" [hidden]="field.hidden" [formGroup]="formGroup!">

    <label class="col-sm-2 col-form-label form-label">
        {{field.label}}
    </label>

    <div class="col-sm-10">

        <label class="pt-2">
            {{value}}
        </label>

    </div>
</div>